import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import { getCurrencySymbol } from 'src/utils/misc';
import { Danger } from './Danger';
import { cardStyles } from '../../styles';

export const CashPlaceholder = () => {
  return (
    <View
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        top: 6,
        marginBottom: 5,
      }}
    >
      <Text style={{ ...cardStyles.value, marginBottom: -1 }}>{getCurrencySymbol()}</Text>
      <Danger noMarginBottom />
    </View>
  );
};
